import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from 'components/footer/Footer';
import 'applications/DefaultCss.scss';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';

const MainLayoutNoHeader: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetect();

  return (
    <div className={`app-amerigo no-header container-wrapper ${isMobile ? 'app-layout-mobile' : isTablet ? 'app-layout-tablet' : 'app-layout-desktop'}`}>
      <div className="container">
        <div className="body">
          <Outlet />
        </div>
        <div className="footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};

MainLayoutNoHeader.displayName = 'MainLayoutNoHeader';

export default MainLayoutNoHeader;
